import dayjs from 'dayjs'
import { OptionalTag } from "../Core/OptionalTag"
import { SessionContextStore } from '../../context/SessionContext';
import { DeclinationApi } from '../../api/decliantion.api';
import { awaitWithLoading,returnDeclinationReason } from '../../services/utils'
import { EventEmitterService, EventKey } from '../../services/EventEmitterService'
import React,{useContext,useState,useEffect} from 'react'
import FlexView from 'react-flexview/lib'
import { Grid, TextField, useMediaQuery,Button,InputAdornment ,RadioGroup,FormControlLabel,Radio} from '@material-ui/core'
import { useForm, Controller } from 'react-hook-form'
import { GlobalTextField } from '../Core/Input/ControlledTextField';


var classNames = require('classnames')

export const ApproveRefferalRequest = (props) => {
    const { register, triggerValidation, errors, getValues, control } = useForm({mode: 'onChange'})

    const isMobile = !useMediaQuery(theme => theme.breakpoints.up('md'));
    const sessionContext = React.useContext(SessionContextStore)
    const { declinationDate,reason ,comment, payload, value } = props
    const [declined , setDeclined] = useState(props.declined)
    const [allowed , setAllowed] = useState(props.allowed)
    const [approvedBy,setApprovedBy] = useState("Skywatch")

    useEffect(()=>{
        setDeclined(props.declined)
    },[props.declined])

    const onApprove = async () => {
        let valid = await triggerValidation()
        if (!valid) return

        let res = await awaitWithLoading(DeclinationApi.manageDeclinations({
            "comment": getValues()['allow_comment'],
            "property": reason,
            "value": value,
            "type": 'Allow',
        }))
        if(res.ok){
            setAllowed(true)
            props.closeReffedRequest(props)
        }
        else{
            EventEmitterService.dispatch(EventKey.ShowError, res)
        }
    }

    
    return (
        <FlexView>
            <FlexView column>
                <Grid className="margin-bottom-basic" spacing={8}>
                    <Grid item sm={6}>
                        <b>Date :</b> {new Date(declinationDate).toLocaleDateString()}
                    </Grid>
                    <Grid className="margin-bottom-basic" item sm={9}>
                        <b>Reason :</b> {returnDeclinationReason(reason)} <br/> <b>Comment :</b> {comment}<br/> 
                    </Grid>
                    <Grid item md={15}>
                        {allowed ? 
                            <div className="approved-div">
                            <img className="approved-img" src={process.env.PUBLIC_URL + '/assets/v-sign.png'} />
                            <div className="text">This refferal was approved</div>
                            </div>
                            :
                            declined ? 
                            <div className="declined-div">
                            <img className="declined-img" src={process.env.PUBLIC_URL + '/assets/x-sign.png'} />
                            <div className="text">This refferal was declined</div>
                            </div>
                            :       
                            <Controller
                            rules={{ required: true }}
                            control={control}
                            name="allow_comment"
                            as={
                              <GlobalTextField
                                label="Do you have any comments for this request?"
                                fullWidth
                                name="allow_comment"
                                errors={errors}
                                helperText={!!errors.allow_comment && 'Required'}
                              />
                            }
                          /> }        
                    </Grid>
                </Grid>
            </FlexView>
            <Grid item sm={1} md={2}>
                {!allowed && !declined  && <button onClick={onApprove} className="approve-button margin-bottom-basic margin-top-large"> Approve </button>}
            </Grid>
        </FlexView>
    )
}